import angular from 'angular';

import configModule from '../config/config-module';
import stripeModule from '../stripe/stripe-module';
import PaymentCtrl from './payment/payment-ctrl';
import ReviewCtrl from './review/review-ctrl';
import ConfirmationCtrl from './confirmation/confirmation-ctrl';
import FailureCtrl from './failure/failure-ctrl';
import VisionCancelCtrl from './vision-cancel/vision-cancel';
import showCardIcon from './review/filters/show-card-icon';
import taxlabel from './review/filters/taxlabel';
import OrderResource from './resources/order';
import ProductsResource from './resources/products';
import PaymentProfileResource from './resources/payment-profile';
import invoiceUrl from './filters/invoice-url.filter';

import stripe from './config/stripe';

export default angular.module('payment', [configModule, stripeModule])
    .controller('PaymentCtrl', PaymentCtrl)
    .controller('ReviewCtrl', ReviewCtrl)
    .controller('ConfirmationCtrl', ConfirmationCtrl)
    .controller('FailureCtrl', FailureCtrl)
    .controller('VisionCancelCtrl', VisionCancelCtrl)
    .factory('OrderResource', OrderResource)
    .factory('ProductsResource', ProductsResource)
    .factory('PaymentProfileResource', PaymentProfileResource)
    .filter('showCardIcon', showCardIcon)
    .filter('taxlabel', taxlabel)
    .filter('invoiceUrl', invoiceUrl)
    .config(stripe)
    .name;



// WEBPACK FOOTER //
// ./payments/payment-module.js